export default "__VITE_ASSET__qYej3Jlg__"